import React from 'react';
import { Box, HStack, Icongraphy, Text } from '@design-system/pc';
import { LoadImage } from '@display-component/pc';
import { Agency } from '@remodeling/shop';
import ResponsiveBox from '@/components/ResponsiveBox/ResponsiveBox';
import useAgencyInformation from './hooks/useAgencyInformation';
import TrackingService from '@/services/tracking';

interface AgencyInformationProps {
  data: Agency;
}

const AgencyInformation = ({ data }: AgencyInformationProps) => {
  const { handleGoShop } = useAgencyInformation({ id: data.id });

  return (
    <ResponsiveBox {...TrackingService.tagGTM('agency_information')} mt={52}>
      <HStack
        space={8}
        alignment="start"
        onClick={handleGoShop}
        width="max-content"
        style={{
          cursor: 'pointer',
        }}
        {...TrackingService.tagGTM('goods_detail_shop_button', {
          'shop-id': data.id,
        })}
      >
        <HStack space={4} width={100}>
          <Icongraphy
            variant="ic_search_store"
            resize
            size={16}
            useFillColor
            color="color_chip.gray.700"
          />
          <Text variant="label_md_m" color="color_chip.gray.800">
            소속 대리점
          </Text>
        </HStack>

        <HStack mt="2px" space={16}>
          <Box width={72} height={72} borderRadius={2}>
            <LoadImage src={data.image?.url} imgFit="cover" />
          </Box>

          <Box flex="1">
            <Text variant="subTitle5" color="color_chip.primary">
              {data.name}
            </Text>
            <HStack space={4} alignment="start" mt="4px">
              <Icongraphy
                variant="ic_location"
                resize
                size={16}
                useFillColor
                color="color_chip.gray.700"
              />
              <Text variant="body2" color="color_chip.gray.700" flex="1">
                {`${data.address?.basic} ${data.address?.detail}`}
              </Text>
            </HStack>
          </Box>
        </HStack>
      </HStack>
    </ResponsiveBox>
  );
};

export default AgencyInformation;
